import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { ClickUpIcon, ClickUpIconBorderless, ClickUpSearchResultIcon } from './icon';

export const clickUpConfig: ThirdPartyConfig = {
	displayName: 'ClickUp',
	id: 'clickup',
	resourceType: ProductResourceTypes3P.ClickUp,
	icon: get3PLogo(ClickUpIcon, 'ClickUp', 'medium'),
	iconBorderless: get3PLogo(ClickUpIconBorderless, 'ClickUp', 'small'),
	searchResultIcon: get3PLogo(ClickUpSearchResultIcon, 'ClickUp', 'large'),
	integrationAri: 'ari:cloud:platform::integration/clickup',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
